import {combineReducers} from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "MEMBER_DELETE_ERROR":
            return action.error;

        case "MEMBER_DELETE_RESET":
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "MEMBER_DELETE_LOADING":
            return action.loading;

        case "MEMBER_DELETE_RESET":
            return null;

        default:
            return state;
    }
}

export function deleted(state = false, action) {
    switch (action.type) {
        case "MEMBER_DELETE_SUCCESS":
            return action.success;

        case "MEMBER_DELETE_RESET":
            return null;

        default:
            return state;
    }
}

export default combineReducers({error, loading, deleted});